<template>
  <div :class="{ [$style.container]: true, [$style.active]: isActive }">
    <div
      :class="{ [$style.panel]: true, [$style.disabled]: disabled }"
      @click="$emit('click', false)"
    >
      <div
        v-if="$slots.hasOwnProperty('icon')"
        :class="$style.icon"
        :style="iconStyles"
      >
        <slot name="icon" />
      </div>

      <div :class="$style.title">
        <template v-if="$slots.hasOwnProperty('title')">
          <slot name="title" />
        </template>
        <template v-else>
          {{ title }}
        </template>
      </div>

      <div :class="$style.switcher" @click.stop="$emit('click', true)">
        <cs-switcher :value="value" :disabled="disabled" />
      </div>
    </div>

    <div v-if="isActive" :class="$style.content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TooglePanel',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    iconStyles: Object,
  },
  computed: {
    isActive() {
      if (this.value) {
        return this.$validate.isObjectWithFields(this.$slots, ['content']);
      }

      return false;
    },
  },
};
</script>

<style lang="sass" module>
  .container
    background-color: #222235
    border-radius: 5px

    &.active
      background-color: #1E1D2F
      box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15)

  .panel
    display: flex
    align-items: center
    padding: 15px
    cursor: pointer

    +respond-to('cramped')
      padding: 20px

    &.disabled
      cursor: default
      opacity: .5

  .content
    padding: 0 15px 15px

    +respond-to('cramped')
      padding: 0 20px 20px

  .icon
    width: 30px
    height: 30px
    flex: none
    display: flex
    align-items: center
    justify-content: center
    margin-right: 10px
    background: linear-gradient(0deg, #181722, #181722), rgba(255, 255, 255, 0.5)
    border-radius: 50px

    +respond-to('cramped')
      width: 40px
      height: 40px
      margin-right: 20px

    svg
      max-width: 18px
      max-height: 18px
      fill: var(--color-icon-primary)

      +respond-to('cramped')
        max-width: 22px
        max-height: 22px

  .title
    flex: 1
    font-weight: 600
    font-size: 14px
    line-height: 20px
    color: #fff
    overflow: hidden
    display: -webkit-box
    -webkit-line-clamp: 2
    -webkit-box-orient: vertical

    +respond-to('cramped')
      font-size: 16px

  .switcher
    flex: none
    display: flex
    justify-content: flex-end
</style>
